// components/alerts/modalArchive.tsx
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  onClose: (confirmed: boolean) => void;
  message: string;
}

const ModalArchive: React.FC<Props> = ({ show, onClose, message }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-99 flex items-center justify-center bg-gray-500/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg">
        <h2 className="!text-lg !font-bold !mb-4 !text-black">Confirmação</h2>
        <p className="!text-gray-500 !mb-6">{t(message)}</p>
        <div className="flex justify-center gap-20">
          <button
            className="!px-6 !py-1 !bg-yellow-500 rounded hover:bg-yellow-600 transition"
            onClick={() => onClose(true)}
          >
            Desarquivar
          </button>
          <button
            className="!bg-red-400 !px-6 !py-1 rounded !text-white"
            onClick={() => onClose(false)}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalArchive;
